// App.jsx
import React, { useEffect } from 'react';

import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './component/Sidebar';
import Topbar from './component/Topbar';
import Footer from './component/Footer';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Scheme from './pages/Scheme';
import Services from './pages/Services';
import Provider from './pages/Provider';
import API from './pages/API';
import Role from './pages/Role';
import Paymode from './pages/Paymode';
import Permission from './pages/Permission';
import Bank from './pages/Bank';
import Member from './pages/Member';
import Commission from "./pages/Commission";
import CommissionSlab from "./pages/CommissionSlab";
import CompanyProfile from './pages/CompanyProfile';
import ProtectedRoute from './component/ProtectedRoute';
import ViewProfile from './pages/ViewProfile'; 
import ApiToken from './pages/ApiToken';
import PayoutApiToken from './pages/PayoutApiToken';
import VerifyToken from './pages/Verify_token';
import FundRequest from './pages/FundRequest';
import Profile from './pages/Profile';
import SetPermission from './pages/SetPermission';
import ForgotPassword from './pages/ForgotPassword';
import CheckSeamless from './pages/CheckSeamless';
import ReportPayin from './pages/PayinReport';
import ReportPan from './pages/pan_report';
import ReportPayout from './pages/PayoutReport';
import MainWallet from './pages/MainWallet';
import PayinWallet from './pages/PayinWallet';
import WalletTransfer from './pages/WalletTransfer';
import Success from './pages/Success';
import Failed from './pages/Failed';
import Checkout from './pages/Checkout';
import MerchantBank from './pages/MerchantBank';
import PayNow from './pages/PayNow';
import PayNow1 from './pages/PayNow1';
import CheckPay from './pages/CheckPay';
import Pay from './pages/Pay';
import KycReturn from './pages/kyc_return';
import TopayOnboarding from './pages/TopayOnboarding';
import Onboarding from './pages/Onboarding';
import onboarded from './pages/onboardold';
import OnbordingSettlement from './pages/OnboardingSettlement';
import SettlementList from './pages/SettlementList';
import SettlementRequestList from './pages/SettlementRequestList';
import HoldingAmountReport from './pages/Holding_Amount_Report';




// Wrapper for route-level body class control
function BodyClassController() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path === "/") {
      document.body.className = "bg-login pace-done";
    } 
    else if(path==="/forgot-password"){
      document.body.className = "bg-login pace-done";
    }
    
    else {
      document.body.className = "bg-default pace-done"; // ya jo dashboard bg hai
    }
    
    const routeTitles = {
      "/dashboard": "Dashboard | SuvidhaPe",
      "/payin": "Payin Reports | SuvidhaPe",
      "/payout": "Payout Reports | SuvidhaPe",
      "/scheme": "Scheme | SuvidhaPe",
      "/services": "Services | SuvidhaPe",
      "/profile": "Profile | SuvidhaPe",
      "/": "Login | SuvidhaPe",
      "/forgot-password": "Forgot Password | SuvidhaPe",
      "/company_profile": "Company Profile | SuvidhaPe",
      "/member": "Member Management | SuvidhaPe",
      "/provider": "Provider Manager | SuvidhaPe",
      "/paymodes": "Paymode Manager | SuvidhaPe",
      "/apitoken": "API Token Manager | SuvidhaPe",
      "/payoutapitoken": "Payout API Token Manager | SuvidhaPe",
      "/fund_request": "Fund Reports | SuvidhaPe",
      "/apis": "API Manager | SuvidhaPe",
      "/bank": "Bank Manager | SuvidhaPe",
      "/roles": "Role Manager | SuvidhaPe",
      "/permissions": "Permission Manager | SuvidhaPe",
      // aur bhi add kar sakte ho
    };
    const title = routeTitles[path] || "SuvidhaPe Admin Panel";
    document.title = title;

  }, [location]);

  return null;
}

function Layout({ children }) {
  return (
    <div className="wrapper">
      <Sidebar />
      <Topbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <BodyClassController />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/check_seamless" element={<CheckSeamless />} />
        <Route path="/success" element={<Success />} />
        <Route path="/failed" element={<Failed />} />
        <Route path="/check_seamless/:txnid" element={<CheckSeamless />} />
        <Route path="/check/:txnid" element={<PayNow />} />
        <Route path="/checkv1/:txnid" element={<PayNow1 />} />
        <Route path="/Pay/:txnid" element={<Pay />} />
        <Route path="/CheckPay/:txnid" element={<CheckPay />} />
        <Route path="/checkout/:txnid" element={<Checkout />} />
        <Route path="/kyc-return" element={<KycReturn />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/onboard" element={<onboarded />} />
        <Route path="/onboarded1" element={<onboarded1 />} />
        {/* <Route path="/onboarded11" element={<onboarded11 />} /> */}
        {/* <Route path="/topay-onboarding" element={<TopayOnboarding />} /> */}
        
        
        {/* PROTECTED ROUTES */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute >
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/scheme"
          element={
            <ProtectedRoute slug="scheme_show">
              <Layout>
                <Scheme />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/services"
          element={
            <ProtectedRoute slug="services_show">
              <Layout>
                <Services />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/provider"
          element={
            <ProtectedRoute slug="provider_manager_show">
              <Layout>
                <Provider />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/apis"
          element={
            <ProtectedRoute>
              <Layout>
                <API />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/roles"
          element={
            <ProtectedRoute>
              <Layout>
                <Role />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/paymodes"
          element={
            <ProtectedRoute>
              <Layout>
                <Paymode />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/apitoken"
          element={
            <ProtectedRoute slug="api_token">
              <Layout>
                <ApiToken />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payoutapitoken"
          element={
            <ProtectedRoute>
              <Layout>
                <PayoutApiToken />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/verifytoken"
          element={
            <ProtectedRoute>
              <Layout>
                <VerifyToken />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/permissions"
          element={
            <ProtectedRoute>
              <Layout>
                <Permission />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/bank"
          element={
            <ProtectedRoute>
              <Layout>
                <Bank />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/member"
          element={
            <ProtectedRoute>
              <Layout>
                <Member />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/merchantbank"
          element={
            <ProtectedRoute>
              <Layout>
                <MerchantBank />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/commission/:schemeId"
          element={
            <ProtectedRoute>
              <Layout>
                <Commission  />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/CommissionSlab/:schemeId"
          element={
            <ProtectedRoute>
              <Layout>
                <CommissionSlab  />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/view_profile/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <ViewProfile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/set_permission/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <SetPermission />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout>
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/company_profile"
          element={
            <ProtectedRoute>
              <Layout>
                <CompanyProfile  />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet_transfer"
          element={
            <ProtectedRoute>
              <Layout>
                <WalletTransfer  />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/pan_report"
          element={
            <ProtectedRoute>
              <Layout>
                <ReportPan />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/fund_request"
          element={
            <ProtectedRoute>
              <Layout>
                <FundRequest  />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payin"
          element={
            <ProtectedRoute>
              <Layout>
                <ReportPayin  />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payout"
          element={
            <ProtectedRoute>
              <Layout>
                <ReportPayout  />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/mainwallet"
          element={
            <ProtectedRoute>
              <Layout>
                <MainWallet  />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payinwallet"
          element={
            <ProtectedRoute>
              <Layout>
                <PayinWallet />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/topay-onboarding"
          element={
            <ProtectedRoute>
              <Layout>
                <TopayOnboarding />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <Layout>
                <Onboarding />
              </Layout>
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/Settlement_Onboarding"
          element={
            <ProtectedRoute>
              <Layout>
                <OnbordingSettlement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settlement_list"
          element={
            <ProtectedRoute>
              <Layout>
                <SettlementList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/holding_amount_report"
          element={
            <ProtectedRoute>
              <Layout>
                <HoldingAmountReport />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settlement_request_list"
          element={
            <ProtectedRoute>
              <Layout>
                <SettlementRequestList />
              </Layout>
            </ProtectedRoute>
          }
        />

        
      </Routes>
    </BrowserRouter>
  );
}

export default App;
